import storage from "../Assets/js/Global";

// Set when the user taps "Skip" on the scan guidelines: the guidelines stay
// hidden on this device until a scan fails, when resetGuidelines() clears it
// along with the "scanGuidelinesSeen" flag.
export const GUIDELINES_SKIPPED_KEY = "scanGuidelinesSkipped";

export const shouldShowGuidelines = (seenKey) =>
  !storage.get(seenKey) && !storage.get(GUIDELINES_SKIPPED_KEY);

// After a scan error the guidelines should come back, even for a user who
// tapped Skip — so this clears the flow's "seen" flag and the skip flag.
export const resetGuidelines = (seenKey) => {
  storage.remove(seenKey);
  storage.remove(GUIDELINES_SKIPPED_KEY);
};
